/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reads_Heading_TaglineInputs */

const en_reads_heading_tagline = /** @type {(inputs: Reads_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More like this`)
};

const ar_reads_heading_tagline = /** @type {(inputs: Reads_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المزيد مثل هذا`)
};

const bn_reads_heading_tagline = /** @type {(inputs: Reads_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এ ধরনের আরও লেখা`)
};

const de_reads_heading_tagline = /** @type {(inputs: Reads_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr davon`)
};

const es_reads_heading_tagline = /** @type {(inputs: Reads_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más contenidos como este`)
};

const fr_reads_heading_tagline = /** @type {(inputs: Reads_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus de contenu similaire`)
};

const pt_reads_heading_tagline = /** @type {(inputs: Reads_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais conteúdos assim`)
};

const zh_reads_heading_tagline = /** @type {(inputs: Reads_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更多类似内容`)
};

const tr_reads_heading_tagline = /** @type {(inputs: Reads_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bunun gibi daha fazlası`)
};

const ru_reads_heading_tagline = /** @type {(inputs: Reads_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ещё подобное`)
};

const pl_reads_heading_tagline = /** @type {(inputs: Reads_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Więcej takich`)
};

/**
* | output |
* | --- |
* | "More like this" |
*
* @param {Reads_Heading_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const reads_heading_tagline = /** @type {((inputs?: Reads_Heading_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reads_Heading_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_reads_heading_tagline(inputs)
	if (locale === "bn") return bn_reads_heading_tagline(inputs)
	if (locale === "de") return de_reads_heading_tagline(inputs)
	if (locale === "es") return es_reads_heading_tagline(inputs)
	if (locale === "fr") return fr_reads_heading_tagline(inputs)
	if (locale === "pt") return pt_reads_heading_tagline(inputs)
	if (locale === "zh") return zh_reads_heading_tagline(inputs)
	if (locale === "tr") return tr_reads_heading_tagline(inputs)
	if (locale === "ru") return ru_reads_heading_tagline(inputs)
	if (locale === "pl") return pl_reads_heading_tagline(inputs)
	return en_reads_heading_tagline(inputs)
});